import { useState } from "react"
import { t } from "i18next"
import { useUser } from "@/apis/bff.ts"
import { Banner } from "@/components/ui/banner.tsx"
import { Button } from "@/components/ui/button.tsx"
import { CaveDialog } from "@/modules/patients/information/cave/cave-dialog.tsx"

interface CaveWarningProps {
  isEditMode: boolean
  message: string | undefined | null
  country: string
}

const CaveWarning = ({ isEditMode, message, country }: CaveWarningProps) => {
  const user = useUser()
  const hasCavePermission = user.isOneOf(["MedicalSupervisor"])
  const [openCave, setOpenDialog] = useState(false)
  const openCaveDialog = () => {
    setOpenDialog(true)
  }

  const closeCaveDialog = () => {
    setOpenDialog(false)
  }
  return (
    <>
      {openCave && (
        <CaveDialog open={openCave} closeDialog={closeCaveDialog} message={message} country={country as string} />
      )}
      <Banner variant="warning">
        <span className="flex w-full content-between">
          <div className="text-on-warning-surface my-auto shrink grow basis-auto self-center text-sm leading-5 max-md:max-w-full">
            {message}
          </div>
          {isEditMode && hasCavePermission && (
            <div className="text-on-warning-surface flex self-center pr-8 text-sm leading-5 font-medium whitespace-nowrap">
              <Button type="button" variant={null} className={"text-on-warning-surface h-5"} onClick={openCaveDialog}>
                {t("common.edit")}
              </Button>
            </div>
          )}
        </span>
      </Banner>
    </>
  )
}
export { CaveWarning }
